const SYSTEM_LABELS = {
  capo: 'capo',
  contano: 'contano',
  rights_services: 'rights.services',
  lynx: 'LYNX',
  hawkeye: 'HAWKEYE',
  monstrs: 'MONSTRS'
}

const SUBSYSTEM_LABELS = {
  all: '全サブシステム',
  red: 'RED',
  blue: 'BLUE',
  green: 'GREEN',
  pink: 'PINK'
}

const RIGHTS_SERVICES_SYSTEM = 'rights_services'
const ALL_RIGHTS_SUBSYSTEMS = 'all'

const htmlTagPattern = /<\/?(p|div|br|ul|ol|li|h[1-6]|strong|em|b|i|a|table|thead|tbody|tr|td|th|pre|code|blockquote)\b[^>]*>/i

export function releaseSystemLabel (value) {
  return SYSTEM_LABELS[value] || value || '-'
}

export function releaseSubsystemLabel (value) {
  return SUBSYSTEM_LABELS[value] || value || ''
}

export function releaseSubsystemBadgeList (release) {
  const subsystemList = Array.isArray(release?.rightsSubsystemList) ? release.rightsSubsystemList : []
  if (subsystemList.length > 0) return subsystemList
  if (release?.system === RIGHTS_SERVICES_SYSTEM) return [ALL_RIGHTS_SUBSYSTEMS]
  return []
}

export function formatReleaseDate (value) {
  if (!value) return '-'
  return String(value).replace('T', ' ').slice(0, 10)
}

export function escapeHtml (value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function sanitizeReleaseHtml (value) {
  const source = String(value || '')
    .replace(/<\s*(script|style|iframe|object|embed)\b[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
    .replace(/<\s*(script|style|iframe|object|embed)\b[^>]*\/?>/gi, '')
    .replace(/\s+on[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/\s+(href|src)\s*=\s*("\s*javascript:[^"]*"|'\s*javascript:[^']*'|javascript:[^\s>]+)/gi, '')

  if (typeof DOMParser === 'undefined') {
    return source
  }

  const parser = new DOMParser()
  const parsed = parser.parseFromString(source, 'text/html')
  parsed.querySelectorAll('script, style, iframe, object, embed').forEach(element => element.remove())
  parsed.body.querySelectorAll('*').forEach(element => {
    Array.from(element.attributes).forEach(attribute => {
      const name = attribute.name.toLowerCase()
      const attrValue = attribute.value.trim().toLowerCase()
      if (name.startsWith('on') || ((name === 'href' || name === 'src') && attrValue.startsWith('javascript:'))) {
        element.removeAttribute(attribute.name)
      }
    })
  })
  return parsed.body.innerHTML
}

export function releaseContentHtml (value) {
  const text = String(value || '').trim()
  if (!text) return '-'
  if (htmlTagPattern.test(text)) {
    return sanitizeReleaseHtml(text)
  }
  return escapeHtml(text).replace(/\n/g, '<br>')
}

export function releaseNoteText (value) {
  return sanitizeReleaseHtml(value)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function releaseNoteExcerpt (value, maxLength = 90) {
  const text = releaseNoteText(value)
  if (!text) return ''
  if (text.length <= maxLength) return text
  return `${text.slice(0, maxLength)}...`
}
